<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow"> 
      <!------------------------search---------------------->
        <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
          <el-form-item style="width:21%">
            <el-date-picker style="width:100%"
              v-model="query.date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd" :unlink-panels="false" @change="queryselect=true">
            </el-date-picker>
          </el-form-item>
          <el-form-item style="width:11%">
            <el-select v-model="query.brandid" clearable filterable placeholder="按品牌" style="width:100%;" @change="queryselect=true">
                <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
              	    <span style="float: left">{{item.name}}</span>
      			        <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
                </el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="width:12%">
              <el-select v-model="query.warehouse" clearable filterable placeholder="按仓库" style="width:100%;" @change="resetSearchParams">
                  <el-option v-for="(item,index) in warehouselists" :label="item.name" :value="item.id" :key="index"></el-option>
              </el-select>
          </el-form-item>
          <!--  -->
          <el-form-item v-if="goodsLocationStatus">
            <el-cascader
              :props="{ label: 'full_code', value: 'id', children: 'children' }"
              v-model="storage_location"
              :options="locationList"
              placeholder="请选择位置"
              clearable
              >
            </el-cascader>
          </el-form-item>
          <el-form-item ref="query" :model="query" v-if="goodsLocationStatus">
            <el-input placeholder="请输入货位" v-model="query.storage_location_keyword" clearable @keyup.enter.native="getList" @change="queryselect=true"></el-input>
          </el-form-item>
          <!--  -->
          <el-form-item style="width:8%">
              <el-select v-model="query.type" clearable placeholder="按类型" style="width:100%;" @change="queryselect=true">
                  <el-option v-for="(item,index) in typelist" :label="item.name" :value="item.name" :key="index"></el-option>
              </el-select>
          </el-form-item style="width:12%">
          <el-form-item ref="query" :model="query">
              <el-input placeholder="商品名称 / 编号" v-model="query.key" clearable @keyup.enter.native="getList" @change="queryselect=true" style="width:100%;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
            <el-button type="primary" icon="el-icon-search" @click="outputinfos">导出</el-button>
          </el-form-item>
        </el-form>
      <!------------------------search end---------------------->
      <div class="backborder2" style="margin-top:10px">
        <el-table :data="lists" v-loading="listLoading">
            <el-table-column label="商品信息">
                <template slot-scope="scope">
                    <span style="float:left;width:100%">{{scope.row.productname}}</span><br/>
                    <span style="float:left;font-size:.7rem;color:rgb(144, 147, 153);line-height:1.2rem">规格：{{scope.row.spec}}</span>
                    <span style="float:left;margin-left:2%;font-size:.7rem;color:rgb(144, 147, 153);line-height:1.2rem">编号：{{scope.row.number}}</span>
                    <span style="float:left;width:100%;font-size:.7rem;color:rgb(144, 147, 153);line-height:1.2rem">品牌：{{scope.row.brandname}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="documents" label="相关单号" width="170"></el-table-column>
            <el-table-column label="商品出库数量(单位/基本单位)" width="130" align="center">
                <template slot-scope="scope">
                    <span>{{scope.row.outnums}} / {{scope.row.baseoutnums}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="warehousename" label="出库仓库" width="110" align="center"></el-table-column>
            <el-table-column label="出库货位" width="225" align="center" v-if="goodsLocationStatus">
                <template slot-scope="scope">
                  <div class="">
                      <div class="cz-product-inventorys-value" v-for="(locationItem,index) in scope.row.storage_location" :key="index">{{locationItem.full_code}} <span style="color: red;">{{(locationItem.available_number)}}</span>;</div>
                  </div>
                </template>
            </el-table-column>
            <el-table-column prop="inputtime" label="出库日期" width="170" align="center"></el-table-column>
            <el-table-column label="出库类型" width="170" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.type=='消费'" style="font-size:.7rem;color:#fff;padding:0.1rem 1rem 0.2rem 1rem;background:#409EFF;border-radius:15px;line-height:1.2rem">消费</span>
                    <span v-if="scope.row.type=='赠送'" style="font-size:.7rem;color:#fff;padding:0.1rem 1rem 0.2rem 1rem;background:#E6A23C;border-radius:15px;line-height:1.2rem">赠送</span>
                    <span v-if="scope.row.type=='自用'" style="font-size:.7rem;color:#fff;padding:0.1rem 1rem 0.2rem 1rem;background:#409EFF;border-radius:15px;line-height:1.2rem">自用</span>
                    <span v-if="scope.row.type=='报废'" style="font-size:.7rem;color:#fff;padding:0.1rem 1rem 0.2rem 1rem;background:#409EFF;border-radius:15px;line-height:1.2rem">报废</span>
                    <span v-if="scope.row.type=='盘点'" style="font-size:.7rem;color:#fff;padding:0.1rem 1rem 0.2rem 1rem;background:#E6A23C;border-radius:15px;line-height:1.2rem">盘点</span>
                    <span v-if="scope.row.type=='采购退货'" style="font-size:.7rem;color:#fff;padding:0.1rem 1rem 0.2rem 1rem;background:#F56C6C;border-radius:15px;line-height:1.2rem">采购退货</span>
                </template>
            </el-table-column>
            <el-table-column v-if="batchStatus" label="操作" width="80" align="center">
                <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="view(scope.row)">查看明细</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="block">
        <!--分页begin-->
          <el-pagination
            @size-change="pageSizeChange"
            @current-change="pageCurrentChange"
            :current-page="query.p"
            :page-sizes="[10, 20, 50]"
            :page-size="query.rollpage"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total_rows">
          </el-pagination>
          <!--分页end-->
        </div>
        </div>

      <!-- 查看明细弹窗开始 -->
      <el-dialog title="查看明细信息" :visible.sync="detailDialogVisible" width="70%" @close="resetDetailData">
          <el-table :data="detailData" border>
              <el-table-column prop="warehouse_name" label="出库仓库" align="center"></el-table-column>
              <el-table-column prop="full_code" label="出库货位" align="center"></el-table-column>
              <el-table-column prop="numbers" label="出库数量" align="center"></el-table-column>
              <el-table-column v-if="batchStatus" prop="batch_sn" label="批次号" align="center" width="180"></el-table-column>
              <el-table-column v-if="batchStatus" prop="start_date" label="生产日期" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.start_date == '0' || !scope.row.start_date">/</span>
                  <span v-else>{{ scope.row.start_date}}</span>
                </template>
              </el-table-column>
              <el-table-column v-if="batchStatus" prop="realvalidity" label="有效期" width="180" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.realvalidity }} {{ validityunitTemp[scope.row.validityunit] }}</span>
                </template>
              </el-table-column>
              <el-table-column v-if="batchStatus" prop="end_date" label="到期日期" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.end_date == '0' || !scope.row.end_date">/</span>
                  <span v-else>{{ scope.row.end_date}}</span>
                </template>
              </el-table-column>
          </el-table>
      </el-dialog>
      <!-- 查看明细弹窗结束 -->

      <!------------------------ 导出信息确认 ------------------------------->
        <el-dialog title="导出信息确认" :visible.sync="outputDialog" width="98%" top="5vh">
      	  <el-button size="medium" type="danger" @click="sureoutput" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
      	  <div id="outputorder">
	      	  <el-table :data="outlists" border v-loading="outlistsLoading">
              <el-table-column prop="documents" label="单据编号"></el-table-column>
              <el-table-column prop="customername" label="客户名称/供应商名称" align="center"></el-table-column>
	          	  <el-table-column prop="brandname" label="品牌" align="center"></el-table-column>
	          	  <el-table-column prop="number" label="商品编号" align="center"></el-table-column>
	          	  <el-table-column prop="productname" label="商品名称" align="center"></el-table-column>
	          	  <el-table-column prop="spec" label="规格" align="center"></el-table-column>
	          	  <el-table-column prop="num" label="数量" align="center"></el-table-column>
	          	  <el-table-column prop="unit" label="单位" align="center"></el-table-column>
                <el-table-column prop="inventory" label="数量（基本单位）" align="center"></el-table-column>
	          	  <el-table-column prop="baseunit" label="单位（基本单位）" align="center"></el-table-column>
	          	  <el-table-column prop="dis_sell" label="单价"></el-table-column>
	          	  <el-table-column prop="total" label="总价"></el-table-column>
	          	  <el-table-column prop="clerkname" label="销售员"></el-table-column>
	          	  <el-table-column prop="type" label="类型"></el-table-column>
	          	  <el-table-column prop="accountname" label="支付方式"></el-table-column>
	          	  <el-table-column prop="warehousename" label="仓库名称"></el-table-column>
                <el-table-column label="货位" prop="storage_location_text" width="150" align="center" v-if="goodsLocationStatus"></el-table-column>
                <el-table-column prop="inputtime" label="出库日期"></el-table-column>
	          	  <el-table-column prop="desc" label="备注"></el-table-column>
	      	  </el-table>
      	  </div>
      	  <div slot="footer" class="dialog-footer">
	          <el-button size="medium" @click="outputDialog=false">取 消</el-button>
	          <el-button size="medium" type="danger" @click="sureoutput">确认导出</el-button>
	      </div>	                
        </el-dialog>
        
        
  </div>
  </transition> 
</template>

<script>
export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Stat/index",
      transitionshow:true,
      lists:[],
      listLoading:false,
      query:{
        act:'outboundnews',
        token:this.$cookies.get('token'),
        brandid:'',
        type:'',
        date:[new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate(),new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate()],
        key:'',
        warehouse:'',
        isexport:0,
        rollpage: 10, // 页大小
        p: 1,
        storage_location:'',
        storage_location_keyword:''
      },
      total_rows: 0,
      brandlists:[],
      warehouselists:[],
      typelist:[
        {name:'消费'},{name:'赠送'},{name:'自用'},{name:'调拨'},
        {name:'报废'},{name:'盘点'},{name:'采购退货'}
      ],
      outlistsLoading:false,
      outputDialog:false,
      outlists:[],
      queryselect:false,
      goodsLocationStatus:false,
      locationList:[],
      storage_location:[],
      goodsLocationStatus:false,
      detailDialogVisible: false, // 控制查看明细弹窗的显示状态
      detailData: [], // 存储查看明细的表格数据
      validityunitTemp: { // 存储有效期单位
        1: '天',
        2: '月',
        3: '年'
      },
      batchStatus: false
    }
  },
  mounted(){
    this.getWarehouse();
    this.getBrand();
    this.getList();
    this.checkLocationStatus()
    this.batchStatus = localStorage.getItem('batchStatus') === 'true'
  },
  methods:{
    //重置表单
    reset() {
        this.$refs.create.resetFields();
    },
    //获取仓库
    getWarehouse(){
      var resource = this.$resource(this.GLOBAL.domain+"Ware/index");
      resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        }else{
          this.warehouselists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    //获取品牌
    getBrand(){
      var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
      resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        }else{
          this.brandlists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    
    //信息列表
    getList(){
      if(this.queryselect==true) {
          this.query.p=1;
          this.query.rollpage=10;	    	
      }
      if(Array.isArray(this.storage_location)&&this.storage_location.length>0){
        const last_item = this.storage_location[this.storage_location.length-1]
        this.query.storage_location=last_item
      }else{
        this.query.storage_location=''
      }
      this.query.isexport=0;
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.save(this.query).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.listLoading = false;
        }else{
          this.lists = JSON.parse(Base64.decode(res.data.Data));
          this.total_rows=parseInt(res.data.count);
          this.listLoading = false;
          if(this.queryselect==true) this.queryselect=false;
          console.log(this.lists, '出库记录')
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.listLoading=false;
      });
    },
    pageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getList();
    },
    
    
    /** 导出库存记录 **/
    outputinfos() {
    	  this.outlistsLoading=true;
    	  this.outputDialog=true;
        var resource = this.$resource(this.GLOBAL.exportUrl+"Stat/index");
        this.query.isexport=1;
        resource.query(this.query).then((res) => {
        if(res.data.Result>0){
            if(res.data.Result=='70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
            this.outlistsLoading=false;
        }else{
            const tempLists = JSON.parse(Base64.decode(res.data.Data));
            if(Array.isArray(tempLists)&&tempLists.length>0){
              for (const element of tempLists) {
                  if(Array.isArray(element.storage_location)&&element.storage_location.length>0){
                    let storage_location_text = ""
                    for (const element_ of element.storage_location) {
                      storage_location_text = `${storage_location_text}${element_.full_code} (${element_.available_number});`
                    }
                    element.storage_location_text=storage_location_text
                  }else{
                    element.storage_location_text=""
                  }             
              }
            }
            // 
            this.outlists = tempLists
            this.outlistsLoading=false;
        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.outlistsLoading=false;
        });
    },
    
    /** 确认导出订单信息 **/
    sureoutput() {
      require.ensure([], () => {
        var { export_json_to_excel } = require('../../vendor/Export2Excel');
        var tHeader = ['单据编号','客户名称/供应商名称','品牌','商品编号','商品名称','规格','数量','单位','数量（基本单位）','单位（基本单位）','单价','总价','销售员/盘点人','类型','支付方式','仓库名称','出库日期','备注'];
        var filterVal = ['documents','customername','brandname','number','productname','spec','num','unit','invnetory','baseunit','dis_sell','total','clerkname','type','accountname','warehousename','inputtime','desc'];
        var list = this.outlists;
        if(this.goodsLocationStatus){
          // 找到“仓库名称”在tHeader中的索引
          const warehouseIndex = tHeader.indexOf('仓库名称');
          // 将“货位”插入到“仓库名称”之后
          tHeader.splice(warehouseIndex + 1, 0, '货位');
          
          // 同步处理filterVal中的对应字段
          const warehouseFilterIndex = filterVal.indexOf('warehousename');
          filterVal.splice(warehouseFilterIndex + 1, 0, 'storage_location_text');
        }
        var data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, '出库记录列表');
        this.outputDialog=false;
      })
    },
    
    //导出表格数据
	formatJson(filterVal, jsonData) {
　　　　return jsonData.map(v => filterVal.map(j => v[j]));
　　},
    checkLocationStatus(){
      const goodsLocationStatus = localStorage.getItem("storageLocationStatus")||''
      if(goodsLocationStatus == "true"){
        this.goodsLocationStatus=true
      }else{
        this.goodsLocationStatus=false
      }      
    },
    resetSearchParams(){
      this.queryselect=true
      this.storage_location=[]
      this.query.storage_location=''
      if(this.goodsLocationStatus){
        this.locationDropdownList()
      }
    },
    locationDropdownList(){
      const address_url = this.GLOBAL.domain+"StorageLocation/cascade_tree"
      const send_data = {warehouse_id:this.query.warehouse,token:this.$cookies.get('token')}
      var resource = this.$resource(address_url);
      resource.save(send_data).then((res) => {
        if(res.data.Result>0){
            this.locationList = []
            this.$message.error(res.data.Message);
        }else{
            var result = JSON.parse(Base64.decode(res.data.Data));
            this.locationList = result
            console.log(result)
        }
      }).catch((res) => {
          this.locationList = []
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    // 查看明细方法
    view(row) {
      this.detailDialogVisible = true; // 打开对话框
      const params = {
        act: 'see_refund_list',
        token: this.$cookies.get('token'),
        id: row.id,
        data_table: row.data_table,
        storage_location_id: row.storage_location_id,
      };
      const resource = this.$resource(this.GLOBAL.domain + 'Stat/index');
      resource.query(params).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result === '70001') this.$router.push('/login');
          this.$message.error(res.data.Message);
        } else {
          this.detailData = JSON.parse(Base64.decode(res.data.Data)); // 填充表格数据
        }
      }).catch((err) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },

    // 重置查看明细数据的方法
    resetDetailData() {
      this.detailData = []; // 关闭弹窗时重置表格数据
    },
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/inventory/Sell.vue